import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { FileTransfer } from '@ionic-native/file-transfer';
import saveAs from 'file-saver';
import { Platform } from 'ionic-angular';
import { FileTransferDownloadOptions, FileTransferNative } from '../../native/file-transfer.native';
import { GlobalServiceProvider } from '../global-service/global-service';
import { PermissionCheckProvider } from '../permission-check/permission-check';
import { StoragePathProvider } from '../storage-path/storage-path';
import { TranslateService } from '@ngx-translate/core';
import { DownloadOptions } from '../../model/file-downloader.model';

declare var cordova: any;

@Injectable()
export class FileDownloaderProvider {
  private renderer: Renderer2;
  public modal: any = null;
  public fillElement: any;
  public textElement: any;
  public timeout: any;
  public countDefaultProgress: number = 0;

  constructor(
    private platform: Platform,
    public fileOpener: FileOpener,
    public transfer: FileTransfer,
    public rendererFactory: RendererFactory2,
    private file: File,
    private permissionCheckProvider: PermissionCheckProvider,
    private storagePathProvider: StoragePathProvider,
    private globalServiceProvider: GlobalServiceProvider,
    private fileTransferNative: FileTransferNative,
    // private toastCtrl: ToastController,
    private translate: TranslateService,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  downloadExcelBlob(data, fileName) {
    let localPath = '';
    if (this.platform.is('android')) {
      localPath = this.file.externalRootDirectory + "Download/GreatDayHr/";
    } else if (this.platform.is('ios')) {
      localPath = cordova.file.cacheDirectory + "/";
    }
    this.file.writeFile(localPath, fileName + ".xlsx", data, { replace: true }).then(res => {
      this.fileOpener.open(
        res.toURL(),
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ).then((res) => {
      }).catch(err => {
        console.log("open error", err)
      });
    }).catch(err => {
      console.log("save error", err)
    });
  }

  downloadPdfBlob(data, fileName) {
    let localPath = '';
    if (this.platform.is('android')) {
      localPath = this.file.externalRootDirectory + "Download/GreatDayHr/";
    } else if (this.platform.is('ios')) {
      localPath = cordova.file.cacheDirectory + "/";
    }
    this.file.writeFile(localPath, fileName + '.pdf', data, { replace: true }).then(res => {
      this.fileOpener.open(
        res.toURL(),
        'application/pdf'
      ).then((res) => {
      }).catch(err => {
        console.log("open error", err)
      });
    }).catch(err => {
      console.log("save error", err)
    });
  }

  /**
   * Funct downloadWithHttp old, recomended use funct download()
   * @param url 
   * @param imageOriginalName 
   * @param customFileName 
   * @returns 
   */
  async downloadWithHttp(url: string, imageOriginalName: string, customFileName?: string) {
    return new Promise(async (resolve, reject) => {
      await this.platform.ready();
      const deviceIos = await this.platform.is('ios');
      this.createCustomProgress();
      try {
        console.log(`customFileName`, customFileName);
        console.log(`imageOriginalName`, imageOriginalName);
        if (this.platform.is('cordova') && deviceIos) await this.permissionCheckProvider.setPathDownload();
        let fileName = customFileName ? customFileName : this.globalServiceProvider.createFilenameDatetime(imageOriginalName).split(" ").join("_");

        if (imageOriginalName) {
          url = url + imageOriginalName;
        }

        const options: FileTransferDownloadOptions = {
          url: url,
          method: 'GET'
        }

        this.fileTransferNative.downloadHttp(options)
          .subscribe(async (event: HttpEvent<any>) => {
            if (event.type === HttpEventType.DownloadProgress) {
              const percentageProgress = Math.round(100 * event.loaded / event.total);
              this.loadingProgress(percentageProgress);
              console.log(`File is ${percentageProgress}% download.`);
            } else if (event.type === HttpEventType.Response) {
              if (this.platform.is('cordova')) {
                try {
                  await this.permissionCheckProvider.setNewPathDownload();
                  const localPath = await this.storagePathProvider.setStorageNativeDownload();

                  await this.writeFile(localPath, fileName, event.body);
                } catch (error) {
                  if (this.modal) this.removeCustomProgress();
                  reject(error);
                }
              } else {
                const isWebview = localStorage.getItem('webOpenFromWebview');
                if (isWebview === 'true') {
                  var message = {
                    action: 'downloadGD',
                    url: event.url,
                    fileName: fileName
                  };
                  this.globalServiceProvider.downloadFromInAppBrowser(message);
                } else {
                  saveAs(event.body, fileName);
                }
              }

              if (this.modal) this.removeCustomProgress();
              resolve(event.body);
            }
          }, error => {
            if (this.modal) this.removeCustomProgress();
            reject(error);
          });
      } catch (error) {
        if (this.modal) this.removeCustomProgress();
        reject(error)
      }
    })
  }

  /**
   * Funct download support method POST & GET
   * @param options 
   * @returns 
   */
  async download(options: DownloadOptions) {
    return new Promise(async (resolve, reject) => {
      try {
        await this.platform.ready();
        this.createCustomProgress();
        const fileName = options.customFileName
          ? options.customFileName
          : this.globalServiceProvider.createFilenameDatetime(options.imageOriginalName).split(" ").join("_");

        if (this.platform.is('ios')) await this.permissionCheckProvider.setPathDownload();
        if (options.imageOriginalName) options.url = options.url + options.imageOriginalName;

        const params: FileTransferDownloadOptions = {
          url: options.url,
          method: options.method,
          body: options.body
        }

        this.fileTransferNative.downloadHttp(params)
          .subscribe(async (event: HttpEvent<any>) => {
            if (event.type === HttpEventType.DownloadProgress) {
              const percentageProgress = Math.round(100 * event.loaded / event.total);
              this.loadingProgress(percentageProgress);
              console.log(`File is ${percentageProgress}% download.`);
            } else if (event.type === HttpEventType.Response) {
              if (this.platform.is('cordova')) {
                try {
                  await this.permissionCheckProvider.setNewPathDownload();
                  const localPath = await this.storagePathProvider.setStorageNativeDownload();
                  this.writeFile(localPath, fileName, event.body);
                } catch (error) {
                  if (this.modal) this.removeCustomProgress();
                  reject(error);
                }
              } else {
                const isWebview = localStorage.getItem('webOpenFromWebview');
                if (isWebview === 'true') {
                  var message = {
                    action: 'downloadGD',
                    url: event.url,
                    fileName: fileName
                  };
                  this.globalServiceProvider.downloadFromInAppBrowser(message);
                } else {
                  saveAs(event.body, fileName);
                }
              }

              if (this.modal) this.removeCustomProgress();
              resolve(event.body);
            }
          }, error => {
            if (this.modal) this.removeCustomProgress();
            reject(error);
          });
      } catch (error) {
        if (this.modal) this.removeCustomProgress();
        reject(error)
      }
    })
  }

  writeFile(localPath: string, fileName: string, blob) {
    return new Promise((resolve) => {
      fileName = encodeURIComponent(fileName);
      const isIncludeMod = fileName.includes('%');

      if (isIncludeMod) {
        fileName = fileName.substring(fileName.lastIndexOf('%') + 1);
      }

      const ext = fileName.substring(fileName.lastIndexOf('.') + 1);
      const mimeType = this.globalServiceProvider.getMIMEtype(ext);

      this.file.writeFile(localPath, fileName, blob, { replace: true })
        .then(res => {
          const newPath = this.storagePathProvider.getPathFolderDownload();
          this.fileOpener.open(res.toURL(), mimeType)
            .then(() => {
              // copy dari folder cache ke folder download
              if (this.platform.is('cordova') && this.platform.is('android')) {
                this.copyFile(localPath, fileName, newPath);
              }

              resolve(true);
            })
            .catch(() => resolve(false));
        })
        .catch(() => resolve(false));
    })
  }

  /**
   * COPY FILE
   * @param localPath 
   * @param fileName 
   * @param newPath 
   */
  copyFile(localPath, fileName, newPath) {
    this.file.copyFile(localPath, fileName, newPath, fileName)
      .then(res => console.log('success copy file', res))
      .catch(error => console.log('error copy file', error));
  }

  // #region Custom Loading Progress

  createCustomProgress() {
    this.modal = this.renderer.createElement('div');
    let parrent = this.renderer.createElement('div');
    this.textElement = this.renderer.createElement('p');
    let progressArea = this.renderer.createElement('div');
    let lineDownload = this.renderer.createElement('div');
    this.fillElement = this.renderer.createElement('div');
    this.renderer.addClass(parrent, 'download-section');
    this.renderer.addClass(this.textElement, 'download-text');
    this.renderer.addClass(progressArea, 'download-progress');
    this.renderer.addClass(lineDownload, 'download-line');
    this.renderer.addClass(this.fillElement, 'download-fill');
    this.renderer.addClass(this.modal, 'overlay-custom');


    this.renderer.appendChild(parrent, this.textElement);
    this.renderer.appendChild(lineDownload, this.fillElement);
    this.renderer.appendChild(progressArea, lineDownload);
    this.renderer.appendChild(parrent, progressArea);
    this.renderer.appendChild(this.modal, parrent);
    this.textElement.innerText = this.translate.instant('Downloading') + "(0%)";
    this.renderer.appendChild(document.getElementsByTagName("ion-app")[0], this.modal);
  }

  loadingProgress(value) {
    this.temporaryProgress();
    if (this.fillElement) this.renderer.setStyle(this.fillElement, 'width', (isNaN(value) ? this.countDefaultProgress : value) + "%");
    if (this.textElement) this.textElement.innerText = this.translate.instant('Downloading') + "(" + (isNaN(value) ? this.countDefaultProgress : value) + "%)";
  }

  temporaryProgress() {
    if (this.countDefaultProgress >= 90) {
      setTimeout(() => {
        if (this.countDefaultProgress <= 98) {
          this.countDefaultProgress++;
        } else {
          this.countDefaultProgress = 99;
        }
      }, 1000);
    } else {
      this.countDefaultProgress += 15;
    }
  }

  removeCustomProgress() {
    this.countDefaultProgress = 100;
    // reset
    setTimeout(() => {
      this.countDefaultProgress = 0;
    }, 1000);

    if (this.modal) {
      this.timeout = setTimeout(() => {
        let blocks = document.getElementsByTagName("ion-app")[0].querySelectorAll(".overlay-custom");
        for (let i = 0; i < blocks.length; i++) {
          this.renderer.removeChild(document.getElementsByTagName("ion-app")[0], blocks[i]);
        }
        this.modal = null;
        this.fillElement = null;
        clearTimeout(this.timeout);
      }, 1500);
    }
  }

  // #endregion Custom Loading Progress

  downloadFileBase64Pdf(file: any, name: string) {
    const fileLink = `data:application/pdf;base64,${file}`;
    const downloadLink = document.createElement("a");
    const fileName = name + ".pdf";
    downloadLink.href = fileLink;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  convertBaseb64ToBlob(b64Data, contentType): Blob {
    contentType = contentType || '';
    const sliceSize = 512;
    b64Data = b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data.replace(/\s/g, '');
    const byteCharacters = window.atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }


}




// WEBPACK FOOTER //
// ./src/providers/file-downloader/file-downloader.ts